import type { AdminDisputeEvidenceResponse } from '@inflip/contracts/admin';
import { useEffect, useState } from 'react';

import { api } from '../lib/api-client';

/**
 * 증거 이미지 — 열 때 짧게 쓰는 주소(10분)를 받아 썸네일로, 누르면 새 탭에서 원본.
 * 기본은 지금 분쟁, recordId 면 지난 분쟁, reportId 면 판매자 위반 신고의 증거
 */
export function EvidenceGallery({
  orderId,
  token,
  recordId,
  reportId,
}: {
  orderId: string;
  token: string;
  recordId?: string;
  reportId?: string;
}) {
  const [items, setItems] = useState<AdminDisputeEvidenceResponse['items'] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (reportId
      ? api.violationReportEvidence(token, orderId, reportId)
      : api.disputeEvidence(token, orderId, recordId)
    )
      .then((r) => !cancelled && setItems(r.items))
      .catch(
        (err: unknown) => !cancelled && setError(err instanceof Error ? err.message : String(err)),
      );
    return () => {
      cancelled = true;
    };
  }, [token, orderId, recordId, reportId]);

  if (error) return <span className="text-xs text-red-600">{error}</span>;
  if (!items) return <span className="text-xs text-muted-foreground">불러오는 중…</span>;
  return (
    <ul className="mt-1 grid grid-cols-5 gap-2">
      {items.map((item, i) => (
        <li key={i}>
          <a href={item.url} target="_blank" rel="noreferrer" title={item.filename}>
            <img
              src={item.url}
              alt={item.filename}
              className="aspect-square w-full rounded-sm bg-muted object-cover"
            />
          </a>
        </li>
      ))}
    </ul>
  );
}
